import {Link} from 'react-router-dom';
import {ButtonProps, LinkProps, SponsorCustomButtonProps} from './type';

const getColorClasses = (outline?: boolean, disabled?: boolean) => {
  return outline
    ? 'bg-white text-farm-shop-500 border-farm-shop-500'
    : `${
        disabled
          ? 'bg-gray-200 text-gray-400 border-gray-200'
          : 'bg-farm-shop-500 text-white border-farm-shop-500'
      } `;
};

const SponsorCustomButton = ({
  title,
  buttonType,
  outline,
  disabled,
  ...props
}: SponsorCustomButtonProps) => {
  const colorClasses = getColorClasses(outline, disabled);
  const commonClasses =
    'w-full min-h-10 shop-btn-border rounded-lg text-sm font-medium text-center';

  if (buttonType === 'button') {
    const {handler} = props as ButtonProps;
    return (
      <button
        className={`${commonClasses} ${colorClasses}`}
        onClick={handler}
        disabled={disabled}
      >
        {title}
      </button>
    );
  } else if (buttonType === 'submit') {
    return (
      <button
        type="submit"
        className={`${commonClasses} ${colorClasses}`}
        disabled={disabled}
      >
        {title}
      </button>
    );
  } else {
    const {link} = props as LinkProps;
    return (
      <Link
        className={`${commonClasses} ${colorClasses} no-underline grid place-items-center`}
        to={link}
      >
        {title}
      </Link>
    );
  }
};

export default SponsorCustomButton;
